

















































































































































































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { useQuery, useResult } from '@vue/apollo-composable';
import axios from 'axios';

import { NOW_START_YEAR } from '@/utils';
import useAuth from '@/useAuth';
import useDelivery from '@/useDelivery';
import {
  deliveryStatsMapper,
  deliveryNoteStatsMapper,
} from './dashboardMapper';

import getDashboardInformation from '@/gql/dashboard/getDashboardInformation.gql';
import getDeliveryNotes from '@/gql/deliveryNote/getDeliveryNotes.gql';
import getOverallDailyReport from '@/gql/dashboard/getOverallDailyReport.gql';
import getCountTempDelivery from '@/gql/dashboard/getCountTempDelivery.gql';
import getCountDelivery from '@/gql/delivery/countDelivery.gql';
import getCountDeliveryNote from '@/gql/deliveryNote/countDeliveryNote.gql';
import getHubs from '@/gql/company/getHubs.gql';

import TransportItem from '@/components/Overall/TransportItem.vue';
import DeliveryMap from '@/components/Overall/DeliveryMap.vue';
import DeliveryHeatMap from '@/components/Map/DeliveryHeatMap.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';

const Shipping = defineComponent({
  components: {
    TransportItem,
    DeliveryMap,
    DeliveryHeatMap,
    CommonPanelWithExpandable,
    ViewDeliveryMarkerModal,
    CommonDeliveryStatusSelect,
  },
  setup() {
    const { me } = useAuth();
    const NOW = useFormat.date().computerShortDate();
    // const NOW = '2023-02-09';
    const toDecimal = (string: any, min = 0, max = 0) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const rerender = ref(true);
    const { translate: translateShipmentStatus } = useDelivery();

    function displayDate(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }

    const filter = reactive({
      status: undefined,
      // DUMMY
      // range: {
      //   from: useFormat.date('2021-11-20').computerShortDate(),
      //   to: useFormat.date('2021-11-20').computerShortDate(),
      // },
      isGoogleMap: false,
      range: {
        from: NOW,
        to: NOW,
      },
      now: {
        from: NOW,
        to: NOW,
      },
      mainSelecthub: undefined as any,
      firstCompareHub: undefined as any,
      secondCompareHub: undefined as any,
    });

    const { result: getOverallDailyReportResult } = useQuery(getOverallDailyReport, computed(() => ({
      // date: NOW,
      filterHubId: filter.mainSelecthub ? filter.mainSelecthub.id : me.hubId,
    })), () => ({ fetchPolicy: 'network-only' }));
    const overallDailyReport = useResult(getOverallDailyReportResult, {
      newDeliveries: 0.0,
      todayCount: 0,
      totalWeight: 0.0,
      dailyCarry: 0.0,
      deliveryTime: 0.0,
      unfinishDelivery: 0,
      unfinishWeight: 0.0,
    }, (data: any) => data.overallDailyReport);

    const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(getCountDelivery, () => ({
      filterOrderDateBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    }), () => ({ fetchPolicy: 'network-only' }));
    const { result: getTempDeliveryResult, loading: countDeliveryApiLoading } = useQuery(getCountTempDelivery, () => ({ filterByDateRange: { from: NOW_START_YEAR, to: NOW } }), () => ({ fetchPolicy: 'network-only' }));
    const waitingToConfirmTempDeliveries = computed(() => {
      const hitIndex = getTempDeliveryResult.value?.countTempDelivery?.findIndex((counter: { count: number; status: string; weight: number }) => counter.status === 'WAITING_TO_CONFIRM');
      if (hitIndex > -1) return getTempDeliveryResult.value?.countTempDelivery[hitIndex];
      return {
        count: 0,
        weight: 0,
      };
    });
    const countTempDeliveryResult = computed(() => waitingToConfirmTempDeliveries.value.count);
    const weightTempDeliveryResult = computed(() => waitingToConfirmTempDeliveries.value.weight);
    const orderStatusCounter = computed(() => deliveryStatsMapper(getCountDeliveryResult.value?.countTodayDelivery, getCountDeliveryResult.value?.countAccumulateDelivery));

    const leadTime = computed(() => orderStatusCounter.value[0]?.weight / overallDailyReport.value?.totalWeight || 0);

    // Query for first hub
    const { result: getFirstHubCompareResult } = useQuery(getCountDelivery, computed(() => ({
      filterHubId: filter.firstCompareHub?.id,
      filterOrderDateBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    })), () => ({ fetchPolicy: 'network-only' }));
    const firstCompareHubResult = computed(() => deliveryStatsMapper(getFirstHubCompareResult.value?.countTodayDelivery, getFirstHubCompareResult.value?.countAccumulateDelivery));

    // Query for second hub
    const { result: getSecondHubCompareResult } = useQuery(getCountDelivery, computed(() => ({
      filterHubId: filter.secondCompareHub?.id,
      filterOrderDateBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    })), () => ({ fetchPolicy: 'network-only' }));
    const secondCompareHubResult = computed(() => deliveryStatsMapper(getSecondHubCompareResult.value?.countTodayDelivery, getSecondHubCompareResult.value?.countAccumulateDelivery));

    // Query for DN
    const { result: getCountDeliveryNoteResult } = useQuery(getCountDeliveryNote, () => ({
      filterUpdatedAtBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    }), () => ({ fetchPolicy: 'network-only' }));
    const deliveryNoteStatusCounter = computed(() => deliveryNoteStatsMapper(getCountDeliveryNoteResult.value?.countTodayDeliveryNote, getCountDeliveryNoteResult.value?.countAccumulateDeliveryNote));

    const { result: getFirstHubCompareResultDn } = useQuery(getCountDeliveryNote, computed(() => ({
      filterHubId: filter.firstCompareHub?.id,
      filterUpdatedAtBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    })), () => ({ fetchPolicy: 'network-only' }));
    const firstCompareHubResultDn = computed(() => deliveryNoteStatsMapper(getFirstHubCompareResultDn.value?.countTodayDeliveryNote, getFirstHubCompareResultDn.value?.countAccumulateDeliveryNote));

    const { result: getSecondHubCompareResultDn } = useQuery(getCountDeliveryNote, computed(() => ({
      filterHubId: filter.secondCompareHub?.id,
      filterUpdatedAtBetween: {
        from: `${NOW} 00:00:00`,
        to: `${NOW} 23:59:59`,
      },
    })), () => ({ fetchPolicy: 'network-only' }));
    const secondCompareHubResultDn = computed(() => deliveryNoteStatsMapper(getSecondHubCompareResultDn.value?.countTodayDeliveryNote, getSecondHubCompareResultDn.value?.countAccumulateDeliveryNote));

    const computedDateInput = computed(() => ({
      future: {
        from: useFormat.date(filter.range.from).dayjs.add(1, 'day').format('YYYY-MM-DD'),
        to: useFormat.date(filter.range.from).dayjs.add(7, 'day').format('YYYY-MM-DD'),
      },
      past: {
        from: useFormat.date(filter.range.from).dayjs.subtract(7, 'day').format('YYYY-MM-DD'),
        to: useFormat.date(filter.range.from).dayjs.subtract(1, 'day').format('YYYY-MM-DD'),
      },
      range: {
        from: `${filter.range.from} 00:00:00`,
        to: `${filter.range.to} 23:59:59`,
      },
      now: {
        from: `${filter.now.from} 00:00:00`,
        to: `${filter.now.to} 23:59:59`,
      },
    }));

    const { result: getDashboardInformationResult, loading: getDashboardInformationLoading, refetch: refetchDashboardInformation } = useQuery(getDashboardInformation, computed(() => ({
      filterDeliveryCreatedAtBetween: filter.range.from ? computedDateInput.value.range : undefined,
      filterDeliveryDateBetween: filter.range.from ? filter.range : undefined,
      todayCount: computedDateInput.value.now.from ? computedDateInput.value.now : undefined,
      now: filter.now.from,
      filterHubId: me.hub?.id || undefined,
    })), () => ({
      fetchPolicy: 'network-only',
    }));

    const { result: getDeliveryNotesResult, loading: getDeliveryNotesLoading, refetch: refetchDeliveryNotes } = useQuery(getDeliveryNotes, computed(() => ({
      filterByStatus: filter.status ? filter.status : undefined,
      filter: {
        OR: [
          {
            column: 'STATUS',
            operator: 'IN',
            value: ['ON_THE_WAY', 'PREPARE_TO_DELIVER', 'SOME_SUCCESS'],
          },
          {
            AND: [
              {
                column: 'UPDATED_AT',
                operator: 'BETWEEN',
                value: [computedDateInput.value.range.from, computedDateInput.value.range.to],
              },
              {
                column: 'STATUS',
                operator: 'IN',
                value: ['SUCCESS', 'NOT_SUCCESS'],
              },
            ],
          },
        ],
      },
      todayCount: computedDateInput.value.now.from ? computedDateInput.value.now : undefined,
      now: filter.now.from,
      filterHubId: me.hub?.id || undefined,
    })), () => ({
      fetchPolicy: 'network-only',
    }));

    const deliveryNotesTodayResult = computed(() => getDeliveryNotesResult.value?.deliveryNotes?.data || []);

    const dashboardInformationResult = useResult(getDashboardInformationResult, [
      { status: 'PREPARE_TO_DELIVER', count: 0, weight: 0 },
      { status: 'ON_THE_WAY', count: 0, weight: 0 },
      { status: 'SUCCESS', count: 0, weight: 0 },
      { status: 'NOT_SUCCESS', count: 0, weight: 0 },
      { status: 'HAS_CANCELED_ORDER', count: 0, weight: 0 },
    ], (data) => data.rangeCountDeliveryNote);

    const acceptShipmentTotalPrice = computed(() => getDashboardInformationResult?.value?.aggregateDeliveries?.acceptShipmentTotalPrice || 0);
    const prepareDeliverTotalPrice = computed(() => getDashboardInformationResult?.value?.aggregatePrepareDeliveries?.prepareDeliverTotalPrice || 0);

    const mapMarkers: any[] = reactive([]);
    const cars: Ref<any[]> = ref([]);
    const dnIds: Ref<any[]> = ref([]);
    const dnColors: Ref<string[]> = ref([]);
    const computedDnColors = computed(() => dnColors.value);

    function mapDeliveryNotesResultToMarker(deliveryNotesFNValue: any) {
      deliveryNotesFNValue.forEach((dn: any, dnIndex: number) => {
        dnIds.value.push((dn as any).id);
        dnColors.value.push('');
        if (!(mapMarkers[dnIndex])) mapMarkers.push([]);

        mapMarkers[dnIndex] = dn.deliveries.map((delivery: any) => ({
          delivery,
          lat: parseFloat(delivery.lat) >= -90 && parseFloat(delivery.lat) <= 90 ? parseFloat(delivery.lat) : 0,
          lng: parseFloat(delivery.long) >= -180 && parseFloat(delivery.long) <= 180 ? parseFloat(delivery.long) : 0,
        }));

        if (dn.locations.length > 0) {
          cars.value.push({
            ...dn.vehicle,
            driver: dn.driver,
            lastPosition: {
              lat: parseFloat(dn.locations[0].lat) >= -90 && parseFloat(dn.locations[0].lat) <= 90 ? parseFloat(dn.locations[0].lat) : 0,
              lng: parseFloat(dn.locations[0].long) >= -180 && parseFloat(dn.locations[0].long) <= 180 ? parseFloat(dn.locations[0].long) : 0,
            },
          });
        }
      });
    }

    watch(() => getDeliveryNotesResult.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        mapDeliveryNotesResultToMarker(deliveryNotesTodayResult.value);
      }
    });
    const viewMapModal = ref(null);
    const mapMarkersForModal: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    const vehicleTraverse: Ref<{ car: any; stamps: { lat: number; lng: number }[] }> = ref({
      car: {
        id: -1,
        license: '',
        lastPosition: { lat: 0, lng: 0 },
      },
      stamps: [],
    });
    const computedCars = computed(() => (vehicleTraverse.value.car.id > -1 ? [vehicleTraverse.value.car] : []));
    function pendingToViewMap(deliveryNote: any) {
      mapMarkersForModal.value = deliveryNote.deliveries.map((delivery: any) => ({
        delivery,
        lat: parseFloat(delivery.lat) >= -90 && parseFloat(delivery.lat) <= 90 ? parseFloat(delivery.lat) : 0,
        lng: parseFloat(delivery.long) >= -180 && parseFloat(delivery.long) <= 180 ? parseFloat(delivery.long) : 0,
      }));

      if (deliveryNote.locations.length > 0) {
        const [lastPos] = deliveryNote.locations;
        vehicleTraverse.value.car = {
          id: deliveryNote.vehicle.id,
          license: deliveryNote.vehicle.license,
          model: deliveryNote.vehicle.model,
          color: deliveryNote.vehicle.color,
          lastPosition: { lat: lastPos.lat, lng: lastPos.long },
          driver: deliveryNote.driver,
        };
        vehicleTraverse.value.stamps = deliveryNote.locations.map((location: any) => ({
          lat: parseFloat(location.lat) >= -90 && parseFloat(location.lat) <= 90 ? parseFloat(location.lat) : 0,
          lng: parseFloat(location.long) >= -180 && parseFloat(location.long) <= 180 ? parseFloat(location.long) : 0,
        }));
        vehicleTraverse.value.stamps.splice(0, 1);
      } else {
        vehicleTraverse.value.car = { id: -1 };
        vehicleTraverse.value.stamps = [];
      }
      (viewMapModal.value as any).open();
    }

    async function sendMessageToAndroid() {
      await axios.post('https://fcm.googleapis.com/fcm/send', {
        to: '/topics/tracking',
        priority: 'high',
        data: {
          Name: 'Get Tracking',
        },
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'key=AAAASVn0KfU:APA91bGBnuzZ-lhoyGlOAytMBFX_6ZTtVwJ6xzb6CpDtRZcxZkc42o-BoUejxQzZNHEX7IPxZFmnxk_tVQYW7d6gW0Ijdw-fS-eVXcTqeFeCzhMK15Idjr1S9daHeJgEo3LpEhKkCatj',
        },
      });
    }

    async function pendingToReloadMap() {
      await sendMessageToAndroid();
      const reloadTimeout = setTimeout(async () => {
        refetchDashboardInformation();
      }, 10000);
    }

    function renderColorDeliveryNote(payload: any) {
      const index = dnIds.value.findIndex((itm: any) => itm === payload.id);
      if (index > -1) {
        rerender.value = false;
        dnColors.value[index] = payload.color;
        rerender.value = true;
      }
    }

    return {
      me,
      toDecimal,
      NOW,
      filter,
      displayDate,
      translateShipmentStatus,
      rerender,

      acceptShipmentTotalPrice,
      prepareDeliverTotalPrice,

      cars,
      dnIds,
      computedDnColors,

      mapMarkers,

      mapMarkersForModal,
      viewMapModal,
      vehicleTraverse,
      computedCars,
      pendingToViewMap,

      pendingToReloadMap,

      renderColorDeliveryNote,

      overallDailyReport,

      leadTime,
      orderStatusCounter,
      deliveryNoteStatusCounter,
      firstCompareHubResult,
      secondCompareHubResult,
      firstCompareHubResultDn,
      secondCompareHubResultDn,

      deliveryNotesTodayResult,
      dashboardInformationResult,

      countTempDeliveryResult,
      weightTempDeliveryResult,

      getHubs,

    };
  },
});

export default Shipping;
